import { useState, useEffect } from "react";
import combinedServices from "../../../../shared/services/user-service";
import categoryIcon from "../../../../assets/images/cat_Icon.png";
import pencilIcon from "../../../../assets/images/pencil.svg";
import Swal from "sweetalert2";

const InventoryComponent = ({
  storeID,
  page,
  limit,
  searchQuery,
  setPage,
  setLimit,
  setSearchQuery,
}) => {
  const [inventoryData, setInventoryData] = useState([]);
  const [totalInventory, setTotalInventory] = useState(0);
  const [deleteTrigger, setDeleteTrigger] = useState(false);
  const [attributesNames, setAttributesNames] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);

  const totalPages = Math.ceil(totalInventory / limit);

  useEffect(() => {
    const fetchInventory = async () => {
      try {
        let inventoryData = await combinedServices.getInventory(
          page,
          limit,
          searchQuery,
          storeID
        );
        if (inventoryData && inventoryData.data) {
          setInventoryData(inventoryData.data.data || []);
          setTotalInventory(inventoryData.data.total || 0);
        }
      } catch (error) {
        console.error("Error fetching Inventory:", error);
      }
    };
    fetchInventory();
  }, [page, limit, searchQuery, deleteTrigger, isModalOpen, storeID]);

  useEffect(() => {
    const fetchAttributes = async () => {
      try {
        const response = await combinedServices.getallAttribute();
        if (response && response.data) {
          const names = response.data.existingCatagory
            .map((attribute) => ({
              [attribute.attribute_id]: attribute.attributes,
            }))
            .reduce((acc, curr) => Object.assign(acc, curr), {});
          setAttributesNames(names);
        }
      } catch (error) {
        console.error("Error fetching attribute names:", error);
      }
    };
    fetchAttributes();
  }, []);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setPage(1);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  const handleLimitChange = (e) => {
    setLimit(Number(e.target.value));
    setPage(1);
  };

  const toggleInventoryStatus = async (id) => {
    try {
      setInventoryData((prevInventoryData) =>
        prevInventoryData.map((item) =>
          item.inv_id === id
            ? { ...item, isAvailable: !item.isAvailable }
            : item
        )
      );

      const response = await combinedServices.changeInvStatus({
        inventory_id: id,
      });

      if (response.status !== 200) {
        setInventoryData((prevInventoryData) =>
          prevInventoryData.map((item) =>
            item.inv_id === id
              ? { ...item, isAvailable: !item.isAvailable }
              : item
          )
        );
        Swal.fire(
          "Warning!",
          "Failed to update status on the server.",
          "warning"
        );
      }
    } catch (error) {
      setInventoryData((prevInventoryData) =>
        prevInventoryData.map((item) =>
          item.inv_id === id
            ? { ...item, isAvailable: !item.isAvailable }
            : item
        )
      );
      console.error("Error changing status:", error);
      Swal.fire("Error!", "Failed to change status of inventory.", "error");
    }
  };

  const handleUpdateQuantity = async (inventory_id, quantity, price) => {
    try {
      if (!inventory_id) {
        throw new Error("inventory ID must be provided.");
      }

      const inventory = { inventory_id, quantity, price };
      const InventoryData = await combinedServices.updateQuantity(inventory);

      if (InventoryData?.status === 200) {
        setIsModalOpen(false);
        Swal.fire(
          "Updated!",
          InventoryData.data.message || "The Inventory has been Updated.",
          "success"
        );
      } else {
        Swal.fire("Warning!", "Error in updation", "warning");
      }
    } catch (error) {
      Swal.fire("Warning!", "Error in updation", error, "warning");
    }
  };

  const handleSelectProduct = (inv_id) => {
    setSelectedProducts((prev) =>
      prev.includes(inv_id)
        ? prev.filter((id) => id !== inv_id)
        : [...prev, inv_id]
    );
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedProducts(inventoryData.map((product) => product.inv_id));
    } else {
      setSelectedProducts([]);
    }
  };

  const handleBulkUpdate = async (updates) => {
    try {
      const response = await combinedServices.bulkUpdateInventory({
        inventory_ids: selectedProducts,
        ...updates,
      });

      if (response.status === 200) {
        Swal.fire("Success!", "Inventory updated successfully.", "success");
        setDeleteTrigger((prev) => !prev);
        setSelectedProducts([]);
        setIsBulkModalOpen(false);
      }
    } catch (error) {
      Swal.fire("Error!", "Failed to update inventory.", "error");
    }
  };

  return (
    <>
      <div className="storeFilter d-flex justify-content-between align-items-center">
        <form>
          <div className="catFilterCont">
            <div className="filWrp d-flex flex-wrap align-items-center">
              <label className="label2">Showing</label>
              <select
                className="formSelect ms-2 me-2"
                value={limit}
                onChange={handleLimitChange}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
              <span className="ent">entries</span>
              <div className="srchGrp ms-3">
                <input
                  type="text"
                  className="formInput"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  placeholder="Search with Product, Category and SKU Code"
                />
              </div>
            </div>
          </div>
        </form>
        <button
          className="nambaBtn"
          onClick={() => setIsBulkModalOpen(true)}
          disabled={selectedProducts.length === 0}
        >
          Update Inventory ({selectedProducts.length})
        </button>
      </div>
      &nbsp;
      <div className="tblWrp">
        <table>
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Product Name</th>
              <th>Category Name</th>
              <th>Attributes</th>
              <th>SKU Code</th>
              <th>Retail Price</th>
              <th>Quantity</th>
              <th>Status</th>
              <th>
                Action
                <input
                  type="checkbox"
                  className="custom-checkbox"
                  style={{ marginLeft: "25px" }}
                  checked={selectedProducts.length === inventoryData.length}
                  onChange={handleSelectAll}
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {inventoryData.length > 0 ? (
              inventoryData.map((product, index) => {
                let attributes = {};
                try {
                  attributes = JSON.parse(product.attribute || "{}");
                } catch (error) {
                  console.error("Failed to parse attributes:", error);
                }

                return (
                  <tr key={product.inv_id}>
                    <td>{(page - 1) * limit + index + 1}</td>
                    <td>
                      <div className="catPara">
                        <img
                          src={
                            product.product?.images
                              ? JSON.parse(product.product.images || "[]")[0]
                              : categoryIcon
                          }
                          alt={product.product?.product_name || "Product Image"}
                        />
                        {product.product?.product_name || "N/A"}
                      </div>
                    </td>
                    <td>{product.category?.category || "N/A"}</td>
                    <td>
                      {attributes && Object.keys(attributes).length > 0 ? (
                        Object.entries(attributes).map(([key, value]) => {
                          const attributeName =
                            attributesNames[key] || "Unknown Attribute";
                          return (
                            <div key={key}>
                              <strong>{attributeName}:</strong>{" "}
                              {Array.isArray(value) ? value.join(", ") : value}
                            </div>
                          );
                        })
                      ) : (
                        <span>N/A</span>
                      )}
                    </td>
                    <td>{product.product?.sku_code || "N/A"}</td>
                    <td>${product.price || "N/A"}</td>
                    <td>{product.quantity}</td>
                    <td>
                      <div style={{height:"35px",alignContent:"center"}}
                        className={`status-badge ${
                          product.quantity === 0
                            ? "out-of-stock"
                            : product.isAvailable
                            ? "available"
                            : "not-available"
                        }`}
                      >
                        {product.quantity === 0
                          ? "Out of Stock"
                          : product.isAvailable
                          ? "Available"
                          : "Not Available"}
                      </div>
                    </td>
                    <td>
                      <div className="tblBtnWrp" style={{ width: "150px" }}>
                        {/* <button className="Btn"> */}
                          <label className="switch" style={{marginLeft:'5px'}}>
                            <input
                              type="checkbox"
                              checked={product.isAvailable}
                              onChange={() =>
                                toggleInventoryStatus(product.inv_id)
                              }
                              disabled={product.loading}
                            />
                            <span className="slider"></span>
                          </label>
                        {/* </button> */}
                        <button
                          className="Btn"
                          onClick={() => {
                            setSelectedProduct(product);
                            setIsModalOpen(true);
                          }}
                        >
                          <img src={pencilIcon} alt="pencilIcon" />
                        </button>
                        <label
                          className="delete-checkbox"
                          style={{ marginLeft: "10px" }}
                        >
                          <input
                            type="checkbox"
                            className="custom-checkbox"
                            checked={selectedProducts.includes(product.inv_id)}
                            onChange={() => handleSelectProduct(product.inv_id)}
                          />
                        </label>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="9" style={{ textAlign: "center" }}>
                  No Products Found
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <div className="tblPagiWrp">
          <ul className="pagination namPagi">
            <li>
              <button
                onClick={() => handlePageChange(page - 1)}
                disabled={page === 1}
              >
                Prev
              </button>
            </li>
            {Array.from({ length: totalPages }, (_, index) => (
              <li key={index}>
                <button
                  className={page === index + 1 ? "active" : ""}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
            <li>
              <button
                onClick={() => handlePageChange(page + 1)}
                disabled={page === totalPages}
              >
                Next
              </button>
            </li>
          </ul>
        </div>
      </div>
      <QuantityModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        product={selectedProduct}
        updateQuantity={handleUpdateQuantity}
      />
      <BulkUpdateModal
        isOpen={isBulkModalOpen}
        onClose={() => setIsBulkModalOpen(false)}
        selectedCount={selectedProducts.length}
        onBulkUpdate={handleBulkUpdate}
      />
    </>
  );
};

const QuantityModal = ({ isOpen, onClose, product, updateQuantity }) => {
  const [quantity, setQuantity] = useState("");
  const [price, setPrice] = useState("");

  useEffect(() => {
    if (product) {
      setQuantity(product.quantity?.toString() || "");
      setPrice(product.price?.toString() || "");
    }
  }, [product]);

  if (!isOpen) return null;

  const handleSave = () => {
    if (product && product.inv_id && /^\d+$/.test(quantity)) {
      updateQuantity(product.inv_id, parseInt(quantity, 10), parseFloat(price));
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setQuantity(value);
    }
  };

  const handlePriceChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^\d*\.?\d{0,2}$/.test(value)) {
      setPrice(value);
    }
  };

  return (
    <div className="catagorylistmodal">
      <div className="catagorylistmodal-content">
        <h2>Update Inventory</h2>
        <br />
        <form className="category-form">
          <label style={{ fontWeight: "800" }} htmlFor="quantity">
            Current Quantity
          </label>
          <input
            id="quantity"
            type="text"
            value={quantity}
            onChange={handleChange}
            placeholder="Enter Quantity"
          />
          <label style={{ fontWeight: "800" }} htmlFor="price">
            Current Price
          </label>
          <input
            id="price"
            type="number"
            value={price}
            onChange={handlePriceChange}
            placeholder="Enter Price"
            min="0"
            step="0.01"
          />
          <div className="catagorylistmodal-actions">
            <div className="cancel-icon" onClick={onClose}>
              &#10006;
            </div>
            <button
              type="button"
              className="save-btn"
              onClick={handleSave}
              disabled={quantity === ""}
            >
              Save
            </button>
          </div>
        </form>
      </div>
      <div className="catagorylistmodal-overlay" onClick={onClose}></div>
    </div>
  );
};

const BulkUpdateModal = ({ isOpen, onClose, selectedCount, onBulkUpdate }) => {
  const [price, setPrice] = useState("");
  const [quantity, setQuantity] = useState("");
  const [status, setStatus] = useState("no-change");

  const handleSubmit = () => {
    const updates = {};

    if (price !== "") {
      updates.price = parseFloat(price);
    }
    if (quantity !== "") {
      updates.quantity = parseInt(quantity, 10);
    }
    if (status !== "no-change") {
      updates.isAvailable = status === "available";
    }

    onBulkUpdate(updates);
    setPrice("");
    setQuantity("");
    setStatus("no-change");
  };

  if (!isOpen) return null;

  return (
    <div className="catagorylistmodal">
      <div className="catagorylistmodal-content">
        <h2 style={{ fontSize: "30px" }}>Update {selectedCount} Items</h2>
        <br />
        <form className="category-form">
          <label style={{ fontWeight: "650" }} htmlFor="quantity">
            New Quantity (leave empty to keep current)
          </label>
          <input
            type="number"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            min="0"
            style={{ width: "100%", boxSizing: "border-box" }}
          />

          <label style={{ fontWeight: "650" }} htmlFor="price">
            New Price (leave empty to keep current)
          </label>
          <input
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            min="0"
            step="0.01"
            style={{ width: "100%", boxSizing: "border-box" }}
          />

          <div className="addCatForm">
            <label htmlFor="status" style={{ fontWeight: "650" }}>
              Status
            </label>
            <div className="form_grpWrp" style={{ width: "100%" }}>
              <div className="form_grp" style={{ width: "100%" }}>
                <select
                  id="status"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  className="form_ctrl cusSel"
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    padding: "8px",
                    margin: "4px 0",
                  }}
                >
                  <option value="no-change">No Change</option>
                  <option value="available">Available</option>
                  <option value="not-available">Not Available</option>
                </select>
              </div>
            </div>
          </div>

          <div className="catagorylistmodal-actions">
            <div className="cancel-icon" onClick={onClose}>
              &#10006;
            </div>
            <button type="button" className="save-btn" onClick={handleSubmit}>
              Update All
            </button>
          </div>
        </form>
      </div>
      <div className="catagorylistmodal-overlay" onClick={onClose}></div>
    </div>
  );
};

export default InventoryComponent;
